import { useState, useEffect } from 'react';
import { fetchAllBills } from '../services/api';

const useApiBills = () => {
  const [apiBills, setApiBills] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadBills = () => {
    setLoading(true);
    setError(null);
    fetchAllBills()
      .then(data => {
        const list = Array.isArray(data) ? data : [];
        setApiBills(list);
      })
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => { loadBills(); }, []);

  return { apiBills, loading, error, refetch: loadBills };
};

export default useApiBills;